import React, { useState } from 'react';
import './App.css';
import './Platoon.css';
import './Activity.css';
import styled from 'styled-components';
import H2 from './Elements/H2';
import H3 from './Elements/H3';
import _Reserve01 from './Reserve/reserve01.jpg';
import _Reserve02 from './Reserve/reserve02.jpg';
import _Reserve03 from './Reserve/reserve03.jpg';
import _Reserve04 from './Reserve/reserve04.jpg';
import { Dialog2 } from './Dialog2Component';
import { HeightType } from './DialogComponent';

const Grid = styled.div`
    display: grid;
    grid-template-columns: 6rem 1fr;
`

const Column1 = styled.div`
    color: #808080;
    font-weight: bold;
`

const Column2 = styled.div`

`

const PaddingLeft = styled.div`
    padding-left: 2rem;
    margin-bottom: 1rem;
`

export const Img = styled.img`
    display: block;
    min-width: 20rem;
    max-width: 30rem;
    height: auto;
    object-fit: contain;
`

export function PlatoonHome() {
    const [isScheduleOpen, setIsScheduleOpen] = useState(false);

    const onScheduleOpen = () => setIsScheduleOpen(true);
    const onScheduleClose = () => setIsScheduleOpen(false);

    return <>
        <div>
            <div className="pl-1">    
                <div className="platoon-flex">
                    <div className="strong-item platoon-col33percent">
                        <i className="fa-3x fas fa-pray font-gray py-3"></i><br/>
                        <strong>信仰の実践</strong>
                        <div className="text-justify px-1">
                            親里ぢばでひのきしんを実践することで、信仰心が培われます
                        </div>
                    </div>

                    <div className="strong-item platoon-col33percent">
                        <i className="fa-3x fas fa-people-carry font-gray  py-3"></i><br/>
                        <strong>体力に応じた作業</strong>
                        <div className="text-justify px-1">
                        心身に心配のある方にも、安心してひのきしんをしていただけます
                        </div>
                    </div>

                    <div className="strong-item platoon-col33percent">
                        <i className="fa-3x fas fa-users font-gray  py-3"></i><br/>
                        <strong>勇み心の共有</strong>
                        <div className="text-justify px-1">
                            同じ髙安の仲間と親睦を深め合い、楽しみながら時間を過ごせます
                        </div>
                    </div>
                </div>

                <H2>要項</H2>

                <strong><a href="https://liff.line.me/1657462595-R32ZaqBq">参加申し込みはこちら</a></strong>

                <Grid>
                    <Column1>期間</Column1>
                    <Column2>立教189年2月2日（月）～22日（日）</Column2>

                    <Column1>集合</Column1>
                    <Column2>
                        <div>月曜日〜土曜日　午前8時に第百母屋玄関前集合</div>
                        <div>※日曜日の予定は、決まり次第お知らせします。</div>
                    </Column2>
                    <Column1>問い合わせ</Column1>
                    <Column2>
                        <div>青年会髙安分会</div>
                        <div>委員長松村天晴TEL 072-941-7005（髙安大教会）</div>
                        <div>ひのきしん部古川貴章TEL 072-223-0814（隆西分教会）</div>
                    </Column2>
                </Grid>

                <H2>家族入隊at home</H2>
                <div>
                    <div>入隊している青年会員の妻・子どもも一緒にひのきしん隊に入隊できる日です。</div>
                    <p>
                        2月14日㈯8:45第百母屋集合　15:00ごろ解散<br/>
                        ※未就学児の参加費は不要ですが、昼食を喫食する場合は一食250円が必要となります<br/>
                    </p>
                </div>

                <H2>申し込み</H2>
                <Grid>
                    <Column1>申し込み</Column1>
                    <Column2>
                        <p>下記リンクより申し込みください。</p>
                        <p style={{ color: 'red' }}><strong>※食数準備の関係から、入隊日の1週間前までに必ずお申し込みください</strong></p>
                        <p>※参加者の都合で申し込みできない場合、代理で申し込むこともできます。ただし、その場合でも自身の所属教会やプロフィールを登録の上、代理で申し込んでください<br/>家族入隊 at homeも同様です</p>
                        <strong><a href="https://liff.line.me/1657462595-R32ZaqBq">参加申し込み</a></strong>
                    </Column2>
                </Grid>

                <H2>参加お供えについて</H2>
                <p>1日500円、1泊500円（5,000円を超えた分は髙安分会より助成します）</p>
                <H3>例）１泊２日の場合</H3>
                <PaddingLeft>
                    （実動）2日　1,000円<br/>
                    　　+<br/>
                    （宿泊）1泊　500円　合計1,500円
                    <Img src={_Reserve01} alt="１泊２日の予約例"/>
                </PaddingLeft>

                <H3>例）実動日前日に宿泊の場合</H3>
                <PaddingLeft>
                    （実動く）1日　500円<br/>
                    　　+<br/>
                    （宿泊）1泊　500円　合計1,000円
                    <Img src={_Reserve02} alt="前日前のり宿泊の例"/>
                </PaddingLeft>

                <H3>例）５泊６日以上の場合</H3>
                <PaddingLeft>
                    （実動）6日　3,000円<br/>
                    　　+<br/>
                    （宿泊）5泊　2,500円<br/>
                    合計<s>5,500円</s>→5,000円<br/>
                    ※5,000円を超える分は髙安分会より助成します
                    <Img src={_Reserve03} alt="5泊6日以上は5,000円が上限の例"/>
                </PaddingLeft>

                <H3>例）すべて日帰り、累計で11日以上の場合</H3>
                <PaddingLeft>
                    （実動）11日　5,500円<br/>
                    　　+<br/>
                    （宿泊）0泊　0円<br/>
                    合計<s>5,500円</s>→5,000円<br/>
                    ※5,000円を超える分は髙安分会より助成します
                    <Img src={_Reserve04} alt="11日間すべて日帰りは5,000円が上限の例"/>
                </PaddingLeft>

                ※初回参加時に、事前に申し込んだ入隊期間分すべての参加お供えを納めてください
            </div>
            <br/><br/>

            <H2>ひのきしん隊一日の流れ</H2>
            <div className="hino-horizon-scroll">
                <div className="hinolife-grid">
                    <div className="hinoday-column">
                        <H3>一日の流れ（月～土）</H3>
                        <Grid>
                            <Column1>6:45</Column1>
                            <Column2>起床</Column2>

                            <Column1>7:00</Column1>
                            <Column2>
                                <div>朝づとめ・朝食</div>
                                <div>※2/16〜朝づとめ6:45</div>
                            </Column2>

                            <Column1>8:00</Column1>
                            <Column2>当日入隊者集合</Column2>

                            <Column1>8:05</Column1>
                            <Column2>百母屋各所清掃</Column2>

                            <Column1>8:45</Column1>
                            <Column2>
                                <div>ラジオ体操</div>
                                <div>全体朝礼</div>
                            </Column2>

                            <Column1>9:00</Column1>
                            <Column2>午前ひのきしん</Column2>

                            <Column1>11:00</Column1>
                            <Column2>昼食、休憩</Column2>

                            <Column1>13:00</Column1>
                            <Column2>午後ひのきしん</Column2>

                            <Column1>16:00</Column1>
                            <Column2>
                                <div>終了、当日入隊者解散</div>
                            </Column2>

                            <Column1>16:00<br/>  ～21:00</Column1>
                            <Column2>入浴可能<br/></Column2>

                            <Column1>17:30</Column1>
                            <Column2>夕づとめ</Column2>

                            <Column1>18:00</Column1>
                            <Column2>修練</Column2>

                            <Column1>19:00</Column1>
                            <Column2>夕食</Column2>

                            <Column1>22:00</Column1>
                            <Column2>消灯</Column2>
                        </Grid>
                        <br/><br/>
                    </div>

                    <div className="hinoday-column">
                        <H3>日曜</H3>
                        <div>※日程が決まり次第お知らせします。</div>
                        {/*<Grid>
                            <Column1>8:30</Column1>
                            <Column2>当日入隊者集合（百母屋）</Column2>

                            <Column1>8:40</Column1>
                            <Column2>百母屋各所清掃</Column2>

                            <Column1>9:15</Column1>
                            <Column2>ラジオ体操、全体朝礼</Column2>

                            <Column1>9:30</Column1>
                            <Column2>午前ひのきしん</Column2>

                            <Column1>11:00</Column1>
                            <Column2>昼食、休憩</Column2>

                            <Column1>13:00</Column1>
                            <Column2>午後ひのきしん</Column2>

                            <Column1>15:30</Column1>
                            <Column2>
                                <div>終了、当日入隊者解散</div>
                                <div>※終礼後、玄関前にて修練(読み物)</div>
                            </Column2>
                        </Grid>*/}
                        <br/><br/>
                    </div>

                    {/*<div className="hinoday-column">
                            <H3>日曜（7月13日）</H3>
                        <Grid>
                            <Column1>9:00</Column1>
                            <Column2>当日入隊者集合（髙安詰所</Column2>

                            <Column1>9:15</Column1>
                            <Column2>午前ひのきしん</Column2>

                            <Column1>11:30</Column1>
                            <Column2>昼食、休憩</Column2>

                            <Column1>13:00</Column1>
                            <Column2>午後ひのきしん</Column2>

                            <Column1>15:00</Column1>
                            <Column2>
                                <div>終了、当日入隊者解散</div>
                            </Column2>
                        </Grid>
                    </div>*/}
                </div>
            </div>
        </div>
    </>
}